var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activeName === "b"
        ? _c(
            "el-table",
            {
              staticClass: "table-expand",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                size: "small",
                data: _vm.list,
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source" },
              }),
              _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "zprice" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.activeName === "a"
        ? _c(
            "el-descriptions",
            {
              staticClass: "expand",
              attrs: { title: "", border: "", column: 3, size: "small" },
            },
            [
              _c("el-descriptions-item", { attrs: { label: "报价日期" } }, [
                _vm._v(_vm._s(_vm.data.settime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "负责人" } }, [
                _vm._v(_vm._s(_vm.data.rname)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "联系人" } }, [
                _vm._v(_vm._s(_vm.data.name)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "联系电话" } }, [
                _vm._v(_vm._s(_vm.data.phone)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "备注" } }, [
                _vm._v(_vm._s(_vm.data.description)),
              ]),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }